import { testimonials } from '@/mocks/comics';

export default function Testimonials() {
  return (
    <section id="reviews" className="relative bg-background-100/40 py-16 md:py-24">
      <div className="container-site">
        <div className="reveal mx-auto max-w-2xl text-center">
          <span className="text-xs font-medium uppercase tracking-[0.3em] text-primary-400">
            漫友口碑
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            漫友们说：追更再也不孤单
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            来自一起看漫画专区的真实同看体验，每一句都是对同看、一起追的认可。
          </p>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((t, idx) => (
            <figure
              key={t.name}
              className={`reveal flex flex-col rounded-2xl border border-background-200/70 bg-background-100/60 p-6 transition-all hover:-translate-y-1 hover:border-secondary-400/50`}
              style={{ transitionDelay: `${(idx % 3) * 90}ms` }}
            >
              <div className="flex gap-0.5 text-secondary-400">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/60 pt-4">
                <img
                  src={t.avatar}
                  alt={`${t.name} 的头像`}
                  className="h-10 w-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-primary-400">{t.tag}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}